import apiCheckFactory from './api-check';

export default apiCheckFactory;



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./index.js
 **/